<template>
  <div class="main">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            工单信息
          </div>
        </template>
        <div class="collapse-content">
          <SiruiSearch
            ref="baseInfoFormRef"
            :query="baseFormData"
            :columns="formColumn"
            :isQueryPanel="false"
            :rules="formRule"
            @changeMethod="changeMethod"
          ></SiruiSearch>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            维修项目
          </div>
        </template>
        <div class="collapse-content">
          <vxe-grid
            border
            show-overflow
            resizable
            ref="settleAccountsRef"
            class="vxe-table-element"
            :id="baseFormData.relatedRepairFlag == '1' ? 'margin-grid' : ''"
            size="mini"
            align="center"
            :auto-resize="true"
            :edit-rules="tableRules"
            :edit-config="
              baseFormData.relatedRepairFlag == '1' ? {} : { trigger: 'click', mode: 'row' }
            "
            :data="tableData"
            :toolbar="{}"
            :valid-config="{ autoPos: true, message: 'inline' }"
            @edit-closed="closeEditTableHandler"
            @select-change="handleSelectionChange"
            @select-all="handleSelectionChange"
            :checkbox-config="checkBoxConfig"
            heigth="300"
          >
            <template v-slot:buttons v-if="baseFormData.relatedRepairFlag == '0'">
              <el-button
                @click="$refs.settleAccountsRef.commitProxy('insert_actived')"
                size="small"
                type="primary"
                class="vxe-btn-primary"
                >新增</el-button
              >
              <el-button
                @click="deleteBtnClickHandler"
                size="small"
                type="danger"
                class="vxe-btn-delete"
                >删除</el-button
              >
            </template>
            <vxe-table-column
              v-for="(item, index) in columnListDefault"
              :key="index"
              :type="item.type"
              :fixed="item.fixed"
              :field="item.field"
              :title="item.title"
              :width="item.width"
              :sortable="item.sortable"
              :edit-render="item.editRender"
            >
            </vxe-table-column>
          </vxe-grid>
        </div>
      </el-collapse-item>
      <footer class="text-center">
        <div style="padding: 10px; background: #fff">
          <el-row class="page-row">
            <el-button type="primary" @click="saveClick">保存</el-button>
            <el-button type="primary" @click="confirmClick">确认派单</el-button>
            <el-button type="primary" @click="cancelClick(true)" plain>取消</el-button>
          </el-row>
        </div>
      </footer>
    </el-collapse>
  </div>
</template>

<script>
  import { tableRules, formRules } from './rule.js';
  import { columnListDefault, formColumnList, checkBoxConfig } from './index.js';
  import API from '@/api/property/workorder.js';
  import mixin from './../mixin';
  import btnMixins from './../btnMixins.js';
  export default {
    name: 'AddWorkorder',
    mixins: [mixin, btnMixins],
    data() {
      return {
        activeNames: ['1', '2'],
        tableRules: tableRules,
        companyName: '',
        departmentNo: '',
        baseFormData: {
          relatedRepairFlag: '0',
          executeMode: '',
          workOrderDepartmentNo: undefined,
          dispatchPersonName: undefined,
          type: '',
          repairNo: undefined,
        },
        tableData: [],
        columnListDefault: columnListDefault,
        ids: [], // 被删除的数据id集合
        selectionList: [],
        checkBoxConfig: checkBoxConfig,
      };
    },
    computed: {
      formColumn() {
        return formColumnList(this);
      },
      formRule() {
        return formRules(this);
      },
    },
    // watch: {
    //   formColumn() {
    //     console.log('触发监听');
    //   },
    // },
    mounted() {
      // 新增
      if (this.$route.query.status == 'add') {
        this.initData();
      }
      // 编辑
      if (this.$route.query.status == 'edit') {
        let id = this.$route.query.id;
        console.log(id);
        this.getDetail(id);
      }
      // 派单
      if (this.$route.query.status == 'dispatch') {
        this.baseFormData.repairNo = this.$route.query.repairNo;
        let id = this.$route.query.id;
        console.log('this.$route.query', this.$route.query);
        this.getRepairData(id);
      }
    },
    methods: {
      async getRepairData(id) {
        this.initData();
        this.baseFormData.relatedRepairFlag = '1';
        let { data } = await this.$axios.post(`${API.REPAIRORDER_DETAIL}/${id}`);
        if (data.code == 0) {
          this.tableData = data.data.repairProjects;
        } else {
          this.$message.error(data.msg);
        }
      },
      initData() {
        this.baseFormData = {
          ...this.baseFormData,
          workOrderCompanyNo: this.userInfo.companyCode,
          workOrderDepartmentNo: this.userInfo.departmentCode,
          dispatchPersonName: this.userInfo.personName,
          dispatchPersonNo: this.userInfo.personNo,
          executeMode: '01',
        };
      },
      // 删除行
      deleteBtnClickHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行再删除');
          return;
        }
        console.log('删除', this.$refs.settleAccountsRef.getData());
        const XIDList = this.selectionList.map((item) => item._XID);
        const idList = this.selectionList.map((item) => item.id).filter((item) => Boolean(item));
        this.ids = [...this.ids, ...idList];
        this.tableData = this.getTableData().filter((item) => !XIDList.includes(item._XID));
        this.selectionList = this.selectionList.filter((item) => !XIDList.includes(item._XID));
      },
      // 确认派单
      async confirmClick() {
        let data = await this.getSubmitData().then((res) => {
          return res;
        });
        if (data.workOrderDTO) {
          if (data.workOrderProjectDTOList.length) {
            let params = { dispatchFlag: true, ...data };
            console.log('确认', { ...params });
            this.loading.startLoading();
            let res = await this.$axios.post(API.WORKORDER_SAVE, { ...params });
            this.loading.endLoading();
            console.log('res', res);
            if (res.data.code == 0) {
              this.$message.success(res.data.msg);
              this.$store.dispatch('tagsView/delView', this.fromPath).then(() => {
                this.$nextTick(() => {
                  this.$router.push(this.path);
                });
              });
            } else {
              this.$message.error(res.data.msg);
            }
          } else {
            this.$message.error('请选择至少一条维修项目');
          }
        }
      },
      // 保存
      async saveClick() {
        let data = await this.getSubmitData().then((res) => {
          return res;
        });
        console.log('data', data);
        if (data.workOrderDTO) {
          if (data.workOrderProjectDTOList.length) {
            let params = { dispatchFlag: false, ...data };
            this.loading.startLoading();
            let res = await this.$axios.post(API.WORKORDER_SAVE, { ...params });
            this.loading.endLoading();
            console.log('res', res);
            if (res.data.code == 0) {
              this.$message.success(res.data.msg);
              this.$store.dispatch('tagsView/delView', this.fromPath).then(() => {
                this.$nextTick(() => {
                  this.$router.push(this.path);
                });
              });
            } else {
              this.$message.error(res.data.msg);
            }
          } else {
            this.$message.error('请选择至少一条维修项目');
          }
        }
      },
      // 关联报修单,派单人
      async changeMethod({ val, prop }) {
        // const rowData = val && Array.isArray(val) ? val[0] : val;
        if (prop == 'repairNo') {
          this.baseFormData.repairNo = val[0].repairNo;
          let id = val[0].id;
          let { data } = await this.$axios.post(`${API.REPAIRORDER_DETAIL}/${id}`);
          if (data.code == 0) {
            this.tableData = data.data.repairProjects;
          }
        }
        if (prop == 'dispatchPersonName') {
          this.baseFormData.dispatchPersonName = val[0].personName;
          this.baseFormData.dispatchPersonNo = val[0].personNo;
        }
        if (prop == 'workOrderCompanyNo') {
          this.$forceUpdate();
        }
        if (prop == 'relatedRepairFlag') {
          console.log('是否关联报修单', val);
          this.$nextTick(() => {
            this.$refs.baseInfoFormRef.$refs.queryFrom.clearValidate();
          });
          if (this.baseFormData.relatedRepairFlag == '0' && this.baseFormData.repairNo) {
            this.baseFormData.repairNo = '';
            this.tableData = [];
          }
        }
      },
      // 获取需要提交的数据
      async getSubmitData() {
        let workOrderDTO = '';
        this.$refs.baseInfoFormRef.validate((valid) => {
          if (valid) {
            const workOrderCompanyName = this.companyList.find(
              (item) => item.value == this.baseFormData.workOrderCompanyNo
            )?.label;
            const workOrderDepartmentName = this.departmentList.find(
              (item) => item.value == this.baseFormData.workOrderDepartmentNo
            )?.label;
            workOrderDTO = {
              ...this.baseFormData,
              companyCode: this.userInfo.companyCode,
              companyName: this.userInfo.companyName,
              departmentCode: this.userInfo.departmentCode,
              departmentName: this.userInfo.departmentName,
              workOrderCompanyName: workOrderCompanyName,
              workOrderDepartmentName: workOrderDepartmentName,
            };
          } else {
            this.$message.error('请检查数据再提交');
            return false;
          }
        });
        let workOrderProjectDTOList = [];
        // console.log("selectionList",this.selectionList)
        await this.$refs.settleAccountsRef.validate((valid) => {
          console.log('selectionList', this.selectionList);
          if (valid) {
            if (this.baseFormData.relatedRepairFlag == '0') {
              workOrderProjectDTOList = this.$refs.settleAccountsRef
                .getTableData()
                .fullData.map((item) => {
                  return {
                    ...item,
                    companyCode: this.userInfo.companyCode,
                    companyName: this.userInfo.companyName,
                    departmentCode: this.userInfo.departmentCode,
                    departmentName: this.userInfo.departmentName,
                  };
                });
            } else {
              workOrderProjectDTOList = this.selectionList.map((item) => {
                return {
                  ...item,
                  companyCode: this.userInfo.companyCode,
                  companyName: this.userInfo.companyName,
                  departmentCode: this.userInfo.departmentCode,
                  departmentName: this.userInfo.departmentName,
                };
              });
            }
          }
        });
        console.log('workOrderProjectDTOList', workOrderProjectDTOList);
        let paramas = { checkFlag: false, workOrderDTO, workOrderProjectDTOList };
        return paramas;
      },
      // 获取详情信息
      async getDetail(id) {
        let { data } = await this.$axios.post(`${API.WORKORDER_DETAIL}/${id}`);
        if (data.code == 0) {
          this.baseFormData = this.translateFiled(data.data, 'workOrderDTO');
          this.tableData = this.translateFiled(
            data.data.workOrderProjectVOList,
            'workOrderProjectVOList'
          );
        }
      },
      change() {
        console.log('change');
      },
      getTableData() {
        const $table = this.$refs.settleAccountsRef;
        return $table.getTableData().fullData;
      },
      fullTableData(tableData) {
        this.tableData = tableData;
      },
      // 选中行
      handleSelectionChange(row) {
        this.selectionList = row.selection;
        console.log(this.selectionList, '选中行');
      },
      handleChange(row, prop) {
        console.log(row, prop);
      },
    },
  };
</script>

<style scoped>
  #margin-grid {
    margin-top: -46px;
  }
</style>
